export const Bet_History_Filter_Games = Object.freeze({
    Wacs: 'WACS',
    Casino: 'Casino',
    Jetfair: 'Jetfair',
    Exchange: 'Exchange',
    Satta: 'Satta Matka',
    Falcon : 'Falcon'
})